export default __webpack_public_path__ + "static/media/facebook.98563981.svg";